import { ApiCore } from '@/services/api/utils/core.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'
import { apiProvider } from '@/services/api/utils/provider.js'

const url = 'user/sign-up'
const plural = 'sign-up'
const single = 'sign-up'

const api = new ApiCore({
	create: true,
	url: url,
	plural: plural,
	single: single
})

export default api
